import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";

export default function PieReport({
  totalUsersActive,
  totalUsersRejected,
  totalUsersPending,
}) {
  const dataD = useMemo(
    () => ({
      labels: ["Inscritos", "Rechazados", "Pendientes"],
      datasets: [
        {
          label: "# of Votes",
          data: [totalUsersActive, totalUsersRejected, totalUsersPending],
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)",
          ],
          borderWidth: 1,
        },
      ],
    }),

    [totalUsersActive, totalUsersRejected, totalUsersPending]
  );

  return (
    <div className="col-12 col-md-4 col-lg-4">
      <div className="sticky-top">
        <Doughnut data={dataD} />
      </div>
    </div>
  );
}
